<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="ma-auto">
    <v-card class="main-card">
      <v-img class="white--text align-end" height="200px" src="@/assets/images/unauthorized.jpg">
        <v-card-title>{{ $t('login.title') }}</v-card-title>
      </v-img>
      <v-card-subtitle>{{ $t('login.subtitle') }}</v-card-subtitle>
      <v-card-text>
        {{ $t('login.content') }}
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn color="primary" text disabled>{{ $t('login.actionRegister') }}</v-btn> -->
        <v-btn color="primary" text href="https://support.evolveip.net/display/proddev/Evolve+Messaging+Help+Center" target="_blank">{{ $t('login.actionHelp') }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SmsLogin'
};
</script>

<style scoped>
.main-card {
  max-width: 500px;
}
</style>
